import { View } from "ui/atoms/view";
import { usePathname } from "expo-router";
import GoBack from "ui/molecules/common/GoBack";
import { Text } from "react-native";
import { Button, ButtonText } from "ui/gluestack/button";
import { Accordion } from "ui/gluestack/accordion";
import { useHandleBowelMovement } from "../hooks/useHandleBowelMovement";
import { BowelMovementHistoryItem } from "../organisms/BowelMovementHistoryItem";
import {
  FormEnums,
  NewFormButtonText,
} from "../../../services/api/types/forms/enums/FormEnums";
import { NoItemsComponent } from "ui/atoms/noItems";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import Pagination from "ui/molecules/pagination/Pagination";
import { useRef } from "react";
import { CreateBowelMovementModal } from "../modals/CreateBowelMovementModal";
import { PermissionCheck } from "app/features/permission/atoms/PermissionCheck";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";

export function BowelMovementTemplate() {
  const pathname = usePathname();
  const newPath = pathname.split("/").slice(0, -1).join("/");
  const { data, isHistoryLoading, handlePageChange, meta } =
    useHandleBowelMovement({
      onSuccess: () => {},
    });
  const tag = FormEnums.BOWEL_MOVEMENT;

  const ref = useRef<React.ComponentRef<typeof CreateBowelMovementModal>>(null);
  const handleShowModal = () => {
    ref.current?.show();
  };

  return (
    <View className="resident-container">
      <View className="flex-row mb-16">
        <CreateBowelMovementModal ref={ref} />
        <GoBack path={newPath} />
      </View>
      <View className="flex-row">
        <Text className="text-lg text-primary-700 font-semibold">
          Bowel Movement
        </Text>
      </View>
      <View className="border border-gray-200 w-full mt-4 mb-11" />
      <PermissionCheck permission={PermissionsEnums.CREATE_BOWEL_MOVEMENT}>
        <View className="flex-row mb-4">
          <Button
            action="primary"
            size="sm"
            className="mb-3 ml-auto"
            onPress={handleShowModal}
          >
            <ButtonText className="text-xs sm:text-base">
              {NewFormButtonText[tag]}
            </ButtonText>
          </Button>
        </View>
      </PermissionCheck>
      <View>
        <View className="flex-column gap-3 ">
          {isHistoryLoading ? (
            <LoadingSpinner />
          ) : data?.length ? (
            <View>
              <Accordion type="single" variant="filled" className="mb-4 w-full">
                {data?.map((log) => (
                  <BowelMovementHistoryItem key={log.id} log={log} />
                ))}
              </Accordion>
              <Pagination meta={meta} onPageChange={handlePageChange} />
            </View>
          ) : (
            <NoItemsComponent
              className="py-5"
              title="No items!"
              subtitle={`${tag && NewFormButtonText[tag] ? ` Click on the "${NewFormButtonText[tag]}" button above to log a new item` : ""}`}
            />
          )}
        </View>
      </View>
    </View>
  );
}
